import request from '../request';
import requestUrl from '../requestUrl';
import requestParam from '../requestParam';

/**
 * 查询 queryKPMG roles list
 * @param {*} s
 */
export const queryKPMGRoleList = params => {
    return request({
        url: requestUrl('/role/queryKPMG'),
        method: 'post',
        data: requestParam(params)
    });
};


/**
 * saveKPMGRole
 * @param {*} s
 */
export const saveKPMGRole = params => {
    return request({
        url: requestUrl('/role/saveKPMGRole'),
        method: 'post',
        data: requestParam(params)
    });
};

/**
 * queryKPMGPermission
 * @param {*} s
 */
export const queryKPMGPermission = params => {
    return request({
        url: requestUrl('/role/queryKPMGPermission'),
        method: 'post',
        data: requestParam(params)
    });
};

/**
 * updateKPMGRole
 * @param {*} s
 */
export const updateKPMGRole = params => {
    return request({
        url: requestUrl('/role/updateKPMGRole'),
        method: 'post',
        data: requestParam(params)
    });
};
